import { Typography } from '@mui/material';
import React from 'react';
import UserProfile from '../../app-layout/side-nav/side-nav.user-profile';

function DriverProfile() {
    return (
        <div>
            <Typography
                variant="h3"
                component="h3"
                sx={{ textAlign: 'center', mt: 3, mb: 3 }}
            >
                Profile
            </Typography>

            <br />

            <UserProfile />

        </div>
    );
}

export default DriverProfile;